import React from 'react'
import { Button, Input } from 'antd'
import { SearchOutlined } from '@ant-design/icons'
import type { Organization } from '../types'
import PlanUpgradeHint from './shared/PlanUpgradeHint'

interface ToolbarProps {
  search: string
  orgCount: number
  peopleCount?: number
  addUserDisabled?: boolean
  addUserHintOrganization?: Organization
  currentCustomerId?: string | null
  onSearchChange: (value: string) => void
  onAddUser: () => void
  onUpgrade?: (organization: Organization) => void
}

const Toolbar: React.FC<ToolbarProps> = ({
  search,
  orgCount,
  peopleCount,
  addUserDisabled = false,
  addUserHintOrganization,
  currentCustomerId,
  onSearchChange,
  onAddUser,
  onUpgrade,
}) => {
  const addButton = (
    <Button
      type="primary"
      className="um-refactor__add-btn"
      disabled={addUserDisabled}
      onClick={onAddUser}
    >
      Add user
    </Button>
  )

  return (
    <div className="um-refactor__toolbar">
      {addUserDisabled && addUserHintOrganization ? (
        <PlanUpgradeHint
          organization={addUserHintOrganization}
          currentCustomerId={currentCustomerId}
          onUpgrade={onUpgrade}
        >
          {addButton}
        </PlanUpgradeHint>
      ) : (
        addButton
      )}
      <Input
        className="um-refactor__search-input"
        placeholder="Search by email, name or NMLS"
        prefix={<SearchOutlined rev={undefined} style={{ color: '#98A2B3' }} />}
        value={search}
        onChange={(e) => onSearchChange(e.target.value)}
        allowClear
      />
      <div className="um-refactor__spacer" />
      <div className="um-refactor__summary">
        {orgCount} organizations{peopleCount === undefined ? '' : ` · ${peopleCount} people`}
      </div>
    </div>
  )
}

export default Toolbar
